var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.spinner})
}
var staticRenderFns = []

export { render, staticRenderFns }